/**
 * @flow
 * @relayHash 8014cb79e5a8b4fc65b0c837149ca466
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CanonicalCategory_project$ref = any;
export type canonical_CanonicalCategory_QueryVariables = {|
  host: string
|};
export type canonical_CanonicalCategory_QueryResponse = {|
  +project: ?{|
    +$fragmentRefs: CanonicalCategory_project$ref
  |}
|};
export type canonical_CanonicalCategory_Query = {|
  variables: canonical_CanonicalCategory_QueryVariables,
  response: canonical_CanonicalCategory_QueryResponse,
|};
*/


/*
query canonical_CanonicalCategory_Query(
  $host: String!
) {
  project(host: $host) {
    ...CanonicalCategory_project
    id
  }
}

fragment CanonicalCategory_project on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      cursor
      node {
        countCanonicalIssues
        countBrokenHreflangs
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "canonical_CanonicalCategory_Query",
  "id": null,
  "text": "query canonical_CanonicalCategory_Query(\n  $host: String!\n) {\n  project(host: $host) {\n    ...CanonicalCategory_project\n    id\n  }\n}\n\nfragment CanonicalCategory_project on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      cursor\n      node {\n        countCanonicalIssues\n        countBrokenHreflangs\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "canonical_CanonicalCategory_Query",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "CanonicalCategory_project",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "canonical_CanonicalCategory_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "offset",
                "value": 0,
                "type": "Int"
              }
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "cursor",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "countCanonicalIssues",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "countBrokenHreflangs",
                        "args": null,
                        "storageKey": null
                      },
                      v2
                    ]
                  }
                ]
              }
            ]
          },
          v2
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4ac8c99f3f806f470f5ebc47dc207645';
module.exports = node;
